// extracted by mini-css-extract-plugin
export default {"CountriesFeature":"wm_a bic_b"};